import React from 'react';

export const ExpandCollapseIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    {...props}
  >
    <path d="M13 0.999918L6.7 6.99999L1.00001 0.999915" stroke="#05050D" strokeWidth="2" />
  </svg>
);
